var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavicon = function SvgFavicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 111,
    fill: "none",
    viewBox: "0 0 23 111"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.011 105.633h16.966v-53.55l-.088-.088c0-.263 0-.614-.087-.878-.088-1.58-.35-3.16-.875-4.916a19.4 19.4 0 0 0-2.448-5.091c-1.225-1.668-2.624-3.424-4.723-5.092-2.186-1.756-6.121-4.74-8.657-5.794v75.409zM10.406 3.888c5.772 0 10.407 4.653 10.407 10.447S16.178 24.78 10.407 24.78C4.634 24.87 0 20.13 0 14.423 0 8.629 4.635 3.888 10.407 3.888",
    clipRule: "evenodd"
  })));
};
export default SvgFavicon;